<app-deposit-container
  *appHasPermission="[
    { resource: Resources.MerchantTransactions, scope: Scopes.Create },
    { resource: Resources.MerchantWallets, scope: Scopes.Read },
    { resource: Resources.MerchantWallets, scope: Scopes.Create },
  ]"
  [formTitle]="'Deposit'"
  [submitButtonText]="'Next'"
  [walletGenerationText]="'Generate Wallet'"
  [enableWalletGeneration]="true"
  [walletPanelTitle]="'Select Wallet'"
  [confirmationTitle]="'Deposit'"
  [entityLabel]="'Merchant'"
  [entityType]="'merchant'"
  [actionButtonText]="'New Deposit'"
  [wallets]="wallets"
  [merchant]="merchant"
  [isLoading]="isLoading"
  [error]="error"
  [entityId]="merchantId"
  [walletResource]="Resources.MerchantWallets"
  [transactionResource]="Resources.MerchantTransactions"
  (depositCompleted)="onDepositCompleted($event)"
  (walletCreated)="onWalletCreated($event)"
  (newDepositRequested)="onNewDepositRequested()"
/>
